// import { useRouter } from 'next/router'
// import { useQuery, UseQueryOptions } from 'react-query'
// import { AxiosError } from 'axios'
// import { getApiClient } from './api-client'
// import { components } from '../generated'
// import { TRANSLATE } from '@plandi/shop/src/shared'
// import type { TranslationDictionary } from './dictionary.type'

import { useQuery, UseQueryOptions } from 'react-query'
import { TranslationDictionary } from './dictionary.type'
import { AxiosError } from 'axios'
import { useRouter } from 'next/router'
import { getApiClient } from './api-client'
import { components } from '../generated'

export const useTranslation = (
  options?: UseQueryOptions<TranslationDictionary['data'], AxiosError>
) => {
  const router = useRouter()
  const locale = router.locale
  return useQuery(
    'translate',
    () =>
      getApiClient(locale ?? 'en')
        .get<components['schemas']['Translate']>(`v1/localization/${locale}`)
        .then(({ data }) => data.data),
    {
      ...options,
      cacheTime: Infinity,
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      refetchInterval: false
    }
  )
}

export const useLocale = () => {
  const router = useRouter()
  return router.locale ?? 'ru'
}
